import React from 'react';
import { Icon } from '@nooz-optics/nooz-components-lib';
import { ILabel } from '../../../../../../utils/types/contentful';
import { DiopterPicker } from '../DiopterPicker/index';
import { Button } from '../../../Elements';

export interface ShopItemQuickBuyProps {
  label: ILabel;
  isHover: boolean;
}

export const ShopItemQuickBuy: React.FC<ShopItemQuickBuyProps> = ({
  label,
  variant,
  shopifyDiopters,
  category,
}) => (
  <>
    <div className='flex justify-center items-center'>
      <Icon iconKey='FaFacebook' />
      <div className='ml-2'>
        <p>{label?.text}</p>
      </div>
    </div>
    <DiopterPicker
      onDiopterChange={(diopter) => setVariant({ ...variant, diopter })}
      variant={variant}
      variants={shopifyDiopters}
      color={category?.color}
    />
  </>
);
